import React, { Component } from "react";
import "../../static/style/wp-content.css";

class PrivacyPolicy extends Component {
  render() {
    return (
      <div className="row">
        <div className="col-sm-12">
          <h1>Tietosuojaseloste</h1>
          <p>Päivitetty ja astunut voimaan: 24.9.2026</p>
          <p>
            Asiakkaidemme yksityisyyden turvaaminen on meille ensisijaisen
            tärkeää. Haluamme, että asiakkaamme voivat luovuttaa
            henkilötietonsa meille luottavaisin mielin. Tässä
            tietosuojaselosteessa kerrotaan, miten Brang Oy käsittelee
            henkilötietoja perintätoiminnassaan. Siinä kerrotaan myös
            henkilötietojen käsittelyyn liittyvät oikeudet sekä oikeuksien
            toteuttamistavat. Sen vuoksi on tärkeää, että tutustut
            tietosuojaselosteeseen.
          </p>

          <h2>1. Rekisterinpitäjä</h2>
          <p>
            BRANG Oy
            <br />
            Y-tunnus: 2494810-3
            <br />
            Pitkämäenkatu 4 A, 20250 Turku
            <br />
            puh. <a href="tel:0400609883">0400 609 883</a>
            <br />
            <a href="mailto:tietosuoja@brang.fi">tietosuoja@brang.fi</a>
          </p>

          <h2>2. Henkilötietojen käsittelyn tarkoitukset ja käsittelyn oikeusperuste</h2>
          <p>
            Tietojasi käsitellään maksujen vastaanottamista ja/tai
            täytäntöönpanotoimia varten, menettelyjemme ja järjestelmiemme
            arvioimiseksi ja kehittämiseksi, saatavien hankintaan liittyvien
            analyysien tekemiseksi ja lakisääteisten velvoitteiden
            noudattamiseksi.
          </p>
          <p>
            Tietenkin saamme käsitellä tietoja vain, jos siihen on olemassa
            oikeudellinen peruste. Käsittelymme on laillista, jos vähintään yksi
            tietosuoja-asetuksen 6 artiklan mukaisista edellytyksistä täyttyy.
            Seuraavassa esitetään avoin yleiskatsaus tarkoituksistamme ja
            tietojenkäsittelyn oikeusperustasta:
          </p>

          <h3>2.1. Maksuvalvonnan hoitaminen ja erääntyneen saatavan perintä</h3>
          <p>
            Henkilötietoja käsitellään laskutus- ja perintätoimeksiantojen
            hoitamiseen sekä perintään liittyvissä riita-, rikos-, konkurssi-,
            velkajärjestely-, yrityssaneeraus- ja hakemusasioissa.
            Henkilötietojen käsittelyn tarkoituksena on mahdollistaa
            luottotietotoiminnan harjoittajan luottotietorekisteristä peräisin
            olevien luottotietojen tallentaminen ja välittäminen
            sopimusasiakkaille luottotietolain säännösten mukaisesti sekä
            luottotietojen käyttäminen perintätoimenpiteistä päättämiseksi.
            Rekisteröityjä tietoja käsitellään myös perintätoiminnan
            harjoittajaa koskevien lakisääteisten velvoitteiden
            toteuttamiseksi. Käsittelyn oikeusperusta on GDPR Art. 6.1. (f)
            rekisterinpitäjän oikeutettu etu ja jossain tapauksessa GDPR Art.
            6.1. (a) rekisteröidyn suostumus.
          </p>

          <h3>2.2. Laskutus- ja perintäpalvelun tuottaminen sopimusasiakkaille</h3>
          <p>
            Käsittelemme sopimusasiakkaan henkilötietoja asiakkaan ja asiakasta
            edustavan henkilön tunnistamiseen, sopimuksen mukaisten palveluiden
            toteuttamiseen, asiakassuhteeseen liittyvään yhteydenpitoon ja
            raportointiin sekä Online-käyttäjien tunnistamiseen. Käsittelyn
            oikeusperusta on GDPR Art. 6.1.(b) sopimuksen toteuttaminen.
          </p>

          <h3>2.3. Markkinointi ja asiakassuhteen hoito</h3>
          <p>
            Käsittelemme henkilötietoja laskutus- ja perintäpalveluiden
            myynnissä, markkinoinnissa ja suoramarkkinoinnissa sekä
            asiakassuhteen hoitoon liittyvässä viestinnässä. Käsittelyn
            oikeusperusta on GDPR Art. 6.1.(a) rekisteröidyn suostumus.
          </p>

          <h3>2.4. Rekrytointi</h3>
          <p>
            Henkilötietoja käsitellään uusien työntekijöiden rekrytointiin ja
            työsuhteen solmimiseksi. Käsittelyn oikeusperusta on GDPR Art.
            6.1.(a) rekisteröidyn suostumus.
          </p>

          <h3>2.5. Kirjanpitolaista johtuvien velvoitteiden täyttäminen</h3>
          <p>
            Käsittelyn oikeusperusta on GDPR Art. 6.1(c) lakisääteisten
            velvoitteiden noudattaminen.
          </p>

          <p>
            Rekisterinpitäjän henkilötietojen käsittelyyn käytettävät
            oikeusperusteet ovat:
          </p>
          <ul>
            <li>
              GDPR Art. 6.1.(a) rekisteröidyn suostumus. Rekisteriin tallennetaan
              vain asian hoitamisen kannalta tarpeelliset tiedot.
            </li>
            <li>GDPR Art. 6.1.(b) sopimuksen toteuttaminen.</li>
            <li>
              GDPR Art. 6.1(c) lakisääteisten velvoitteiden noudattaminen ja/tai
            </li>
            <li>GDPR Art. 6.1.(f) rekisterinpitäjän oikeutettu etu.</li>
          </ul>

          <h2>3. Mitä henkilötietoja käsittelemme?</h2>
          <p>
            Rekisteröidyistä kerätään vain palveluiden tarjoamisen ja tässä
            tietosuojaselosteessa mainittujen tarkoitusten toteuttamiseksi
            tarpeellisia tietoja. Rekisteröidyistä voidaan tallentaa
            esimerkiksi seuraavia tietoja:
          </p>
          <ul>
            <li>asiakasnumero</li>
            <li>toimeksiantonumero</li>
            <li>nimi</li>
            <li>syntymäaika</li>
            <li>henkilötunnus</li>
            <li>osoite</li>
            <li>puhelinnumero</li>
            <li>sähköpostiosoite</li>
            <li>yhteyshenkilöiden tai edunvalvojien nimet ja yhteystiedot</li>
            <li>pankkiyhteystiedot</li>
            <li>
              sähköisen palvelun käyttäjätiedot ja muut toimeksiannon hoitamisen
              kannalta tarpeelliset tiedot
            </li>
          </ul>
          <p>Rekisteriin voidaan tallentaa myös</p>
          <ul>
            <li>myyntireskontratiedot</li>
            <li>saatavan määrää koskevat tiedot</li>
            <li>saatavan perustetta ja maksamista koskevat tiedot</li>
            <li>perintätoimenpiteitä koskevat tiedot</li>
            <li>
              laskutus- tai perintätoimeksiannon kohteena olevan itse antamat
              tiedot
            </li>
            <li>
              toimeksiantajan ilmoittamat laskutus- ja/tai perintätoimeksiannon
              hoitamiseen liittyvät tiedot sekä viranomaisilta ja julkisista
              rekistereistä saatavat toimeksiannon hoitamisen kannalta
              tarpeelliset tiedot
            </li>
          </ul>
          <p>
            Lisäksi rekisteröidyistä voidaan käsitellä verkkokäyttäytymiseen liittyviä
            tietoja esimerkiksi evästeiden tai vastaavien teknisten tunnistetietojen avulla.
          </p>

          <h2>4. Mitä kautta keräämme henkilötietoja?</h2>
          <p>
            Asiakkaaltamme ja sinulta saamiemme henkilötietojen lisäksi
            keräämme tietoja myös muilta, niin sanotuilta kolmansilta
            osapuolilta. Tilanteesta riippuen nämä voivat olla viranomaisia
            (esim. ulosottomiehet, tuomioistuimet, vankeinhoitolaitokset),
            asianajajia/oikeudellisia edustajia, edunvalvojia, julkisia
            rekistereitä ja yrityksiä, jotka toimittavat henkilötietoja (esim.
            luottolaitokset).
          </p>
          <p>
            Keräämme asiakkailta ja kolmansilta osapuolilta seuraavia tietoja:
          </p>
          <ul>
            <li>
              Nimiä, osoitetietoja, henkilötunnuksia, yhteystietoja,
              laskutustietoja, sopimustietoja, aiempaa asiaan liittyvää
              viestintää ja maksutietoja – asiakkailtamme.
            </li>
            <li>
              Osoite- ja yhteystietoja varmistaaksemme, että meillä on oikeat
              osoitetiedot sinusta – julkisista rekistereistä.
            </li>
            <li>
              Taloudelliset tiedot, esimerkiksi tiedot tuloistasi, menoistasi,
              mahdollisista luottositoumuksistasi, tiedot maksujen
              laiminlyönneistä ja velkasaldosta – luottolaitoksilta ja
              viranomaisilta.
            </li>
            <li>
              Henkilötunnukset. Käsittelemme henkilötunnuksia niin vähän kuin
              mahdollista ja silloin, kun se on selkeästi perusteltua
              käsittelyn tarkoituksen kannalta, esimerkiksi kun meidän on
              tunnistettava sinut tiettyyn tarkoitukseen – julkisista
              rekistereistä.
            </li>
            <li>
              Henkilökohtaiset tiedot. Voimme saada sinusta henkilötietoja
              viranomaiskäsittelyn yhteydessä (esim. velkajärjestelyt). Voimme
              saada asiaankuuluvia henkilötietoja myös muilta edustajilta –
              viranomaisten edunvalvojilta, asianajajilta/oikeudellisilta
              edustajilta.
            </li>
          </ul>

          <h2>5. Henkilötietojen säilyttäminen</h2>
          <p>
            Henkilötietoja säilytetään niin kauan kuin se on tarpeen tässä
            tietosuojaselosteessa määriteltyjen tarkoitusten toteuttamiseksi,
            ellei lainsäädäntö edellytä tietojen säilyttämistä pidempään.
            Säilytysaika voi määräytyä esimerkiksi Suomen kirjanpitolain
            (1336/1997) tai perintätoiminnan harjoittajien rekisteröinnistä
            annetun lain (2018/411) vaatimusten mukaisesti. Asiakkaan tiedot
            poistetaan rekisteristä lain edellyttämän määräajan päätyttyä tai
            kun niiden käsitteleminen ei ole enää tarpeellista. Mikäli
            rekisterissä havaitaan käsittelyn kannalta virheellinen,
            tarpeeton, puutteellinen tai vanhentunut henkilötieto, tieto
            oikaistaan tai poistetaan rekisterinpitäjän omasta aloitteesta tai
            rekisteröidyn pyynnöstä.
          </p>
          <p>
            Säilytämme henkilötietojasi niin kauan kuin se on tarpeen sitä
            laillista tarkoitusta varten, johon tiedot kerättiin, tai niin kauan
            kuin meillä on oikeutettu etu säilyttää tiedot. Tietojesi
            säilytysaika voi määräytyä myös erityislainsäädännön perusteella.
          </p>
          <p>
            Perintätoimeksiantoon liittyviä tietoja säilytämme lain mukaan viisi
            (5) vuotta perintätoimeksiannon lopettamisesta lukien, ellei muualla
            laissa säädetä tätä pidemmästä säilytysajasta.
          </p>
          <p>
            Riita-asiaan tai muuhun lakimiestoimeksiantoon liittyviä tietoja
            säilytämme asianajoliiton suositukseen perustuen 10 vuotta
            toimeksiannon lopettamisesta lukien.
          </p>
          <p>
            Kirjanpitoon liittyviä tilitapahtumia säilytämme kirjanpitolain
            mukaisesti kuusi (6) vuotta kirjanpitovuoden lopusta lukien.
          </p>
          <p>
            Tilanteissa, joissa meihin voi kohdistua hyvitys- tai
            korvausvaatimus, säilytämme vahinkotapahtumaan liittyviä tietoja
            vanhentumislain mukaisesti kolmen (3) vuoden ajan vahingon
            havaitsemisesta, jotta voimme puolustaa itseämme oikeudellisia
            vaatimuksia vastaan. Rahanpesun torjuntaan tai petosten torjuntaan
            liittyvät tutkinnat saattavat tietyissä tilanteissa edellyttää
            tietojen tavanomaisesta poikkeavaa säilytysaikaa.
          </p>
          <p>
            Voit lähettää Brangin tietosuojavastaavalle tietosuoja-asetuksen 17
            artiklan mukaisen tietojen poistopyynnön osoitteeseen
            <a href="mailto:tietosuoja@brang.fi">tietosuoja@brang.fi</a>.
          </p>

          <h2>6. Säännönmukaiset tietojen luovutukset</h2>
          <p>
            Rekisteriin merkittyjä tietoja voidaan siirtää ja luovuttaa
            rekisteristä toimeksiantosopimusten ja kulloinkin voimassa olevan
            lainsäädännön sallimissa ja velvoittamissa tilanteissa seuraaville
            tahoille:
          </p>
          <ul>
            <li>toimeksiantajalle</li>
            <li>
              laskutus- ja perintäasiakkaalle itselleen tai tämän määräämälle
              taholle
            </li>
            <li>tuomioistuimille</li>
            <li>poliisi- ja ulosottoviranomaisille</li>
            <li>luottotietoyhtiöille sekä yhteystietopalveluyrityksille</li>
          </ul>
          <p>
            Lisäksi tietoja voidaan luovuttaa tietojärjestelmiä ja muita
            tietoteknisiä palveluita tuottaville palveluntarjoajille ja muille alihankkijoille.
          </p>
          <p>
            Luottotietotoiminnan harjoittajan luottotietorekisteristä peräisin
            olevia luottotietoja voidaan välittää sopimusasiakkaille.
          </p>

          <h2>7. Tietojen siirto EU:n / ETA:n ulkopuolelle</h2>
          <p>
            Pyrimme aina siihen, että henkilötietoja käsitellään EU:n/ETA:n
            alueella. Jos henkilötietoja siirretään EU- tai ETA-alueen
            ulkopuolelle, varmistamme, että tiedot suojataan parhaalla
            mahdollisella tavalla. Tietoja siirretään ainoastaan, jos niitä
            suojataan riittävän vahvasti, tai jos käytössä on soveltuvia
            suojaustoimenpiteitä, kuten yritystä koskevia sitovia sääntöjä,
            standardisoituja tietosuojamääräyksiä, hyväksytty toimintaohje tai
            yrityksen sisäisiä sääntöjä.
          </p>

          <h2>8. Henkilötietojen suojaaminen</h2>
          <p>
            Henkilötietojen käsittelyssä pyritään varmistamaan henkilötietojen
            turvallisuus, mukaan lukien suojaaminen luvattomalta käsittelyltä
            sekä vahingossa tapahtuvalta häviämiseltä, tuhoutumiselta tai
            vahingoittumiselta.
          </p>
          <p>
            Tietojen suojaamiseksi käytetään asianmukaisia teknisiä ja
            organisatorisia suojatoimia. Henkilötietoja käsittelevät yrityksessä
            tehtävään ohjeistetut henkilöt, joille on myönnetty käyttöoikeus.
            Käyttöoikeudet ovat henkilökohtaiset ja toimenkuvakohtaisesti
            rajattu. Kaikkia henkilötietojen käsittelijöitä sitoo salassapito- ja
            vaitiolovelvollisuus myös käyttöoikeuden päättymisen jälkeen.
          </p>
          <p>
            Rekisterin käyttöä valvotaan ja käyttövaltuudet tarkistetaan
            säännöllisin väliajoin. Rekisterin manuaalinen aineisto säilytetään
            rekisterinpitäjän toimipaikassa lukitussa tilassa.
          </p>
          <p>
            IT-järjestelmiin tallennetut tiedot on suojattu asianmukaisin
            tietoteknisin ratkaisuin. Järjestelmään pääsy vaatii käyttäjätunnuksen
            ja salasanan. Palvelinympäristö on suojattu salasanoilla ja
            asianmukaisella palomuurilla. Tietoliikenne kulkee salattuna.
          </p>
          <p>
            Lisäksi rekisterinpitäjän tietoverkko ja laitteisto, jolla rekisteri
            sijaitsee, on suojattu palomuurilla ja muiden teknisten toimenpiteiden
            avulla. Henkilötietoja sisältävien aineistojen hävitys tehdään
            tietoturvallisesti.
          </p>
          <p>
            Henkilötietojen käsittelyä voidaan ulkoistaa palveluntarjoajille tai
            alihankkijoille, jolloin henkilötietojen käsittelyn asianmukaisuus ja
            lainmukaisuus varmistetaan sopimusvelvoittein.
          </p>

          <h2>9. Rekisteröidyn oikeudet</h2>
          <h3>9.1. Tarkastusoikeus ("rekisteriote")</h3>
          <p>
            Rekisteröidyllä on tietosuoja-asetuksen mukainen oikeus tarkistaa,
            mitä häntä koskevia tietoja rekisterinpitäjän
            henkilötietorekisteriin on tallennettu. Rekisteröidyn tulee esittää
            tarkastuspyyntö rekisterinpitäjälle kirjallisesti postilla
            osoitteeseen:
          </p>
          <p>
            BRANG Oy / tietosuojavastaava
            <br />
            Pitkämäenkatu 4 A
            <br />
            20250 Turku
            <br />
            Tai sähköisesti: <a href="mailto:tietosuoja@brang.fi">tietosuoja@brang.fi</a>
          </p>
          <p>
            Pyynnössä tulee mainita rekisteröidyn nimi, yhteystiedot (osoite,
            sähköpostiosoite ja/tai puhelinnumero) sekä tarkastettavat tiedot.
            Tarkastusoikeus toteutetaan ilman aiheetonta viivytystä
            tietosuoja-asetuksen mukaista määräaikaa noudattaen.
          </p>

          <h3>9.2. Oikeus tietojen oikaisemiseen</h3>
          <p>
            Rekisteröidyllä on oikeus vaatia virheellisten, epätarkkojen,
            puutteellisten tai vanhentuneiden tietojen oikaisemista.
            Korjauspyyntö voidaan esittää tietosuojavastaavalle, ja pyynnössä
            tulee yksilöidä vaadittavat korjaukset sekä niiden perusteet.
            Virheelliset tiedot korjataan henkilöllisyyden varmistamisen
            jälkeen.
          </p>

          <h3>9.3. Oikeus tietojen poistamiseen ("oikeus tulla unohdetuksi")</h3>
          <p>
            Rekisteröidyllä on oikeus pyytää tietojensa poistamista, jos
            tietojen käsittely ei ole tarpeen. Poistopyynnöt käsitellään, ja
            tiedot poistetaan, ellei ole perusteltua syytä niiden säilyttämiseen
            (esim. lakisääteiset velvoitteet). Rekisterinpitäjä voi kieltäytyä
            poistamasta tietoja, jos tietojen säilyttäminen on tarpeen
            oikeudellisten vaatimusten laatimiseksi, esittämiseksi tai
            puolustamiseksi.
          </p>

          <h3>9.4. Oikeus käsittelyn rajoittamiseen</h3>
          <p>
            Rekisteröidyllä on oikeus pyytää tietojen käsittelyn rajoittamista
            esimerkiksi silloin, kun tietojen paikkansapitävyys on
            kiistanalainen. Rajoittamispyynnöt esitetään kirjallisesti
            tietosuojavastaavalle.
          </p>

          <h3>9.5. Oikeus vastustaa käsittelyä</h3>
          <p>
            Rekisteröidyllä on oikeus vastustaa henkilötietojen käsittelyä, jos
            tietoja käsitellään rekisterinpitäjän oikeutetun edun perusteella.
            Rekisterinpitäjä ei saa jatkaa tietojen käsittelyä, ellei voida
            osoittaa, että käsittelyyn on huomattavia ja perusteltuja syitä,
            jotka syrjäyttävät rekisteröidyn edut, oikeudet ja vapaudet, tai jos
            käsittely on tarpeen oikeudellisten vaatimusten laatimiseksi,
            esittämiseksi tai puolustamiseksi.
          </p>

          <h3>9.6. Oikeus tietojen siirtämiseen</h3>
          <p>
            Rekisteröidyllä on tietyissä tilanteissa oikeus saada häntä koskevat
            tiedot koneellisesti luettavassa muodossa ja siirtää tiedot toiselle
            rekisterinpitäjälle. Tämä koskee tietoja, jotka rekisteröity on itse
            toimittanut rekisterinpitäjälle ja jotka käsitellään automaattisesti
            suostumuksen tai sopimuksen perusteella.
          </p>

          <h3>9.7. Suoramarkkinoinnin kielto-oikeus</h3>
          <p>
            Rekisteröidyllä on oikeus kieltää tietojensa käyttö
            suoramarkkinointiin. Tämä oikeus voidaan toteuttaa milloin tahansa
            ottamalla yhteyttä rekisterinpitäjään.
          </p>

          <h3>9.8. Automaattinen päätöksenteko ja profilointi</h3>
          <p>
            Palvelun toteuttamiseen ei liity automaattista päätöksentekoa.
          </p>
          <p>
            Profilointi tarkoittaa henkilötietojen automaattista käsittelyä
            henkilön tiettyjen henkilökohtaisten ominaisuuksien arvioimiseksi,
            erityisesti analysoitaessa tai ennustettaessa hänen työsuoritustaan,
            taloudellista tilannettaan, terveydentilaansa, henkilökohtaisia
            mieltymyksiään, mielenkiinnon kohteitaan, luotettavuuttaan,
            käyttäytymistään, sijaintiaan tai liikkeitään.
          </p>

          <h2>10. Valitusoikeus</h2>
          <p>
            Rekisteröidyllä on oikeus tehdä valitus tietosuojavaltuutetun
            toimistolle, jos hän katsoo, että hänen henkilötietojaan on
            käsitelty tietosuoja-asetuksen vastaisesti.
          </p>
          <p>
            Valvontaviranomaisen yhteystiedot:
          </p>
          <p>
            Nimi: Tietosuojavaltuutetun toimisto
            <br />
            Sähköposti: <a href="mailto:tietosuoja@om.fi">tietosuoja@om.fi</a>
            <br />
            Osoite: PL 800, 00521 Helsinki
            <br />
            Puhelin: <a href="tel:0295666700">029 56 66700</a>
            <br />
            Nettisivut: <a href="https://tietosuoja.fi/etusivu">https://tietosuoja.fi/etusivu</a>
          </p>

          <h2>11. Tietosuojavastaavan yhteystiedot</h2>
          <p>
            Jos sinulla on jotain kysyttävää tavoistamme käsitellä
            henkilötietoja, ota meihin yhteyttä. Voit ottaa yhteyttä Brang Oy:n
            tietosuojavastaavaan:
          </p>
          <p>
            Rekisterinpitäjä: BRANG Oy
            <br />
            Tietosuojavastaava: Sara Saksi
            <br />
            Yhteystiedot: <a href="mailto:tietosuoja@brang.fi">tietosuoja@brang.fi</a>
          </p>

          <h2>12. Muutokset tietosuojaselosteeseen</h2>
          <p>
            Tätä tietosuojaselostetta voidaan muuttaa ja päivittää
            tietosuojalainsäädännön muutosten, toimintatapojen muutosten tai
            muiden tarpeellisten syiden vuoksi. Kaikki muutokset julkaistaan
            tällä sivulla, ja merkittävistä muutoksista voidaan ilmoittaa myös
            suoraan rekisteröidyille. On suositeltavaa tarkistaa tämä
            tietosuojaseloste säännöllisesti mahdollisten muutosten varalta.
          </p>
        </div>
      </div>
    );
  }
}

export default PrivacyPolicy;



// WEBPACK FOOTER //
// ./src/containers/static/PrivacyPolicy.js